import { GET_DATA_CONFIRM_SUCCEEDED, REQUERT_CONFIRM_FAILED } from "../actions/actionTypes";

const ConfirmPageReducer = (DataPlan = [], actions) => {
    switch (actions.type) {
        case GET_DATA_CONFIRM_SUCCEEDED:
            if(Object.keys(actions.DataPlan).length > 0)
            {
                return {...DataPlan,DataPlan: actions.DataPlan};
            }
            else
            {
                return {...DataPlan,DataPlan: []};
            }
        case REQUERT_CONFIRM_FAILED:
            return {...DataPlan,DataPlan: []};
        default:
            return DataPlan;
    }
}
export default ConfirmPageReducer;